exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buttons[data-v-13135552] {\n  margin-top: 270px;\n}", ""]);

// exports
